<template>
  <div class="bonus"></div>
</template>

<script>
//script
import Tools from '../../scripts/tools';
import { gsap } from 'gsap';
//Global
import Global from '../../scripts/Global';

export default {
  data() {
    return {
      data: {},
    };
  },
  components: {},
  created() {},
  computed: {},
  methods: {
    jump(event) {
      if (event) {
        Global.curr = {
          ...data,
        };
        Global.ssq.b1 = true;
        this.$router.replace('/yu');
      } else {
        this.$router.replace('/rodemap/ssq/03');
      }
      console.log(event, 'event');
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.bonus {
  background-image: url(//cdn.original-fun.com/tmp/未中奖.jpg);
  background-position: center;
  width: 100vw;
  height: 100vh;
  max-width: 75vh;
  margin: 0 auto;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
